import React from "react";
import "./Login.css";

function LoginPage({
  memberId,
  setMemberId,
  password,
  setPassword,
  handleLogin,
  error
}) {

  return (
    <div className="main-container">
      
      <div className="top-header">
        <div className="logo-section">
          <img src="/logo.png" alt="logo" className="logo" />
          <div>
            <h2>SMB MEMBERS</h2>
            <span>INTERNET BANKING</span>
          </div>
        </div>
      </div>

      <div className="login-section">

        {/* LEFT LOGIN CARD */}
        <div className="login-card">
          <h3>Login using</h3>
          <button className="tab-btn">Login ID / Customer ID</button>

          <label>Login ID / Customer ID</label>
          <input
            type="text"
            placeholder="Enter ID"
            value={memberId}
            onChange={(e) => setMemberId(e.target.value)}
          />

          <label>Password</label>
          <input
            type="password"
            placeholder="Enter Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <p className="forgot">Forgot password</p>

          <button className="login-btn" onClick={handleLogin}>
            Login
          </button>

          {/* 🔥 Error message from App.js */}
          {error && <p style={{ color: "red", marginTop: "10px" }}>{error}</p>}
        </div>

        {/* RIGHT SIDE DESIGN */}
        <div className="right-side">
          <div className="welcome-text">
            <p className="welcome-small">WELCOME TO</p>
            <h2 className="foundation-name">
              RED SMBS MICRO FACILITY FOUNDATION
            </h2>
            <h1>Internet Banking</h1>
          </div>

          <img src="/girl.png" alt="girl" className="girl-img" />

          <div className="qr-box">
            <img src="/qr.png" alt="qr" />
          </div>
        </div>

      </div>
    </div>
  );
}

export default LoginPage;